module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.2cf4dc03.png";